import React from 'react'

import { GovAndMenuWrapper } from '../GovAndMenuWrapper/GovAndMenuWrapper'
import { Icon } from '../Icons/Icon'

import userIcon from '../../images/Icon_User.svg'

export interface CSRHeaderProps {
  beneficiary: string;
  languageToggleLink: string;
}

export const CSRHeader: React.FC<CSRHeaderProps> = ({ beneficiary, languageToggleLink }) => (
  <GovAndMenuWrapper languageToggleLink={languageToggleLink} isLoggedIn={false}>
    <div className='ch-c-csr-header__icon-container'>
      <Icon text={beneficiary} img={userIcon} />
    </div>
  </GovAndMenuWrapper>
)
